import Button from "@mui/material/Button/Button";
import React, { useContext, useEffect, useState } from "react";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";
import { ButtonOptionsProps } from "../interfaces/firmaInterfaces";

export const ButtonTerminarFirmado = ({
  label = "",
  ...props
}: ButtonOptionsProps) => {
  const { startFinishFirmaAnticipada, statusFirma } = useContext(
    FirmaElectronicaContext
  );

  const [disabledButton, setDisabledButton] = useState(false);

  const existFirmante = statusFirma?.missing[0]?.data?.find(
    (firmante) => firmante.singleName !== ""
  );

  useEffect(() => {
    isDisabledButton();
    // eslint-disable-next-line
  }, [statusFirma, existFirmante]);

  const isDisabledButton = () => {
    if (statusFirma && existFirmante) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  };

  const handleClickButtonSubmit = () => {
    setDisabledButton(true);
    startFinishFirmaAnticipada();
    setTimeout(() => {
      setDisabledButton(false);
    }, 2000);
  };

  return (
    <Button
      onClick={() => handleClickButtonSubmit()}
      disabled={disabledButton}
      {...props}
    >
      {label}
    </Button>
  );
};
